var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .667H7.5a4.167 4.167 0 0 0-4.166 4.166v2.5h-2.5v3.333h2.5v6.667h3.333v-6.666h2.5l.834-3.334H6.667v-2.5A.833.833 0 0 1 7.501 4H10V.667Z",
    fill: "#3C5A9A"
  })));
};
export default SvgFacebook;